<div class="aeg-admin-invoices-tab">
    <div class="aeg-u-bg-alt aeg-u-box-padding">
        <div class="aeg-u-bg-white aeg-u-box-padding">
            <aeg-search-invoice @search="onSearch" :default-query="defaultSearchQuery" :enable-service-filter="true" :enable-customer-reference-filter="false" />
        </div>
    </div>

    <aeg-admin-purchase-invoices :is-loading="isLoading" :hide-header-pagination="false" :purchase-invoices="purchaseInvoices" @change-page="goToPage" />
</div>


